import React from "react";
import { makeStyles } from "@mui/styles";
import { IconButton, Typography } from "@mui/material";

import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { useState } from "react";
import { Password } from "@mui/icons-material";

const myStyles = makeStyles({
  inputContainer: {
    marginBottom: "20px",
    position: "relative",
  },
  inputField: {
    marginTop: "10px",
    width: "100%",
    padding: "15px 50px 15px 0",
    fontSize: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    borderBottom: "1px solid #DFDFDF",
    "&:focus": {
      borderBottom: "1px solid #06623B",
    },
  },
  showPassword: {
    position: "absolute",
    top: "45%",
    right: 0,
    // transform: "translateY(-50%)",
  },
});

const StandardInput = (props) => {
  const { label, placeholder, type, value, onChange } = props;
  const classes = myStyles();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={classes.inputContainer}>
      <Typography
        variant="body2"
        color="#1E293B"
        sx={{ fontSize: "18px", fontWeight: 400 }}
      >
        {label}
      </Typography>

      <input
        placeholder={placeholder}
        className={classes.inputField}
        {...props}
        type={
          type === "password" && showPassword
            ? "text"
            : type === "password" && !showPassword
            ? "password"
            : type
        }
        value={value}
        onChange={onChange}
      />
      {type === "password" && (
        <div className={classes.showPassword}>
          <IconButton
            aria-label="show-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <VisibilityOffRoundedIcon color="#06623B" />
            ) : (
              <VisibilityRoundedIcon color="#06623B" />
            )}
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default StandardInput;
